import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SketchPicker } from 'react-color';
import { ChromePicker } from 'react-color'
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { envAwarePost } from "../../../util/util";
import classes from "../Profile.module.css"


function ColorPickerOverlay({
    colorPickerDisplayed,
    setColorPickerDisplayed,
    handleColorSave,
    dbColor,
    type
}) {

    const [chromePickerColor, setChromePickerColor] = useState("#870000")


    const popover = (
        <div>
            <SketchPicker
                width="250px"
                color={chromePickerColor}
                onChangeComplete={(color) => {
                    setChromePickerColor(color.hex)
                }}
            />
        </div>
    )

    const determineColorButtonTitle = ()=> (
        !dbColor?.length ? "Choose Color" :
        colorPickerDisplayed ? "Save" : "Update"
    )


    return (

        <OverlayTrigger trigger="click" placement="top" overlay={popover}>
            <div className={`d-inline-block ${colorPickerDisplayed && "pt-2"}`}>
                <Button
                    onClick={() => {
                        !colorPickerDisplayed && setChromePickerColor(dbColor);
                        handleColorSave(chromePickerColor, type);
                    }}>
                    {
                    determineColorButtonTitle()
                    }
                </Button>
                {colorPickerDisplayed &&
                    <Button
                        variant='danger'
                        className="mx-2"
                        onClick={() => {
                            setColorPickerDisplayed(prev => !prev);

                        }}>
                        Cancel
                    </Button>}
            </div>
        </OverlayTrigger>
    )
}


function TrainerPageColors({
    textButtonColor,
    setTextButtonColor,
    backgroundColor,
    setBackgroundColor,
    buttonTextColor,
    setButtonTextColor
    }) {


    const [backgroundDisplayed, setBackgroundDisplayed] = useState(false);
    const [textButtonDisplayed, setTextButtonDisplayed] = useState(false);
    const [buttonTextDisplayed, setButtonTextDisplayed] = useState(false);



    function handleSubmit(type, color) {

        let payload = {};
        payload[type] = color;

        envAwarePost("api/users/api/",
            {
                action: 'updateTrainerPageCustomizer',
                ...payload
            })
    }



    function handleColorSave(chromePickerColor, type) {
        if (type === "backgroundColor") {
            if (backgroundDisplayed) {
                handleSubmit(type, chromePickerColor);
                setBackgroundColor(chromePickerColor);
            } 
            setBackgroundDisplayed(prev => !prev)
        } else if (type === "textButtonColor") {
            if (textButtonDisplayed) {
                handleSubmit(type, chromePickerColor);
                setTextButtonColor(chromePickerColor);
            }
            setTextButtonDisplayed(prev => !prev)
        } else if (type==="buttonTextColor") {
            if (buttonTextDisplayed) {
                handleSubmit(type, chromePickerColor);
                setButtonTextColor(chromePickerColor);
            }
            setButtonTextDisplayed(prev => !prev) 
        }
    }


    return (
        <>

            {/* BACKGROUND PICKER */}
            <Form.Group className="form-group" >
                <Form.Label> Background Color
                    <br />
                    <small>
                        <i class="fa fa-info-circle mr-2"></i>
                        this will update the background color of specific page elements. <br/>
                        <i> Refresh your personalized trainer page to see updates. </i>
                    </small>
                </Form.Label>

                <div>
                    <div className={`${classes.swatch}`}>
                        <div
                            className={`${classes.colorSelect} mb-2`}
                            style={{ background: backgroundColor }}
                        />

                        <div className="text-center">
                            <ColorPickerOverlay
                                colorPickerDisplayed={backgroundDisplayed}
                                setColorPickerDisplayed={setBackgroundDisplayed}
                                handleColorSave={handleColorSave}
                                dbColor={backgroundColor}
                                type="backgroundColor"
                            />
                           
                                {!backgroundDisplayed && <OverlayTrigger overlay={<Tooltip>Reset to default</Tooltip>}>
                                    <Button
                                        variant="outline-danger"
                                        size="sm"
                                        className="ml-2"
                                        onClick={() => {
                                            handleSubmit("backgroundColor", "default")
                                            setBackgroundColor("");
                                        }}
                                    >
                                        <i class="fas fa-undo"></i>
                                    </Button>
                                </OverlayTrigger>}
                        </div>


                    </div>
                </div>
            </Form.Group>

            {/* TEXT AND BUTTON COLOR PICKER */}
            <Form.Group className="form-group" >
                <Form.Label className="d-block"> Text and Button Color

                    <br />

                    <small>
                        <i class="fa fa-info-circle mr-2"></i>
                        this will update specific text colors as well as all button backgrounds. <br/>
                        <i> Refresh your personalized trainer page to see updates. </i>

                    </small>
                    <br />
                </Form.Label>
                <div className={`${classes.swatch}`}>
                    <div
                        className={`${classes.colorSelect} mb-2`}
                        style={{ background: textButtonColor }}

                    />
                    <div className="text-center">
                        <ColorPickerOverlay
                            colorPickerDisplayed={textButtonDisplayed}
                            setColorPickerDisplayed={setTextButtonDisplayed}
                            handleColorSave={handleColorSave}
                            dbColor={textButtonColor}
                            type="textButtonColor"

                        />
                          {!textButtonDisplayed && <OverlayTrigger
                            overlay={
                                <Tooltip>Reset to default</Tooltip>
                            }>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="ml-2"
                                onClick={() => {
                                    handleSubmit("textButtonColor", "default");
                                    setTextButtonColor("");
                                }}
                            >
                                <i class="fas fa-undo"></i>
                            </Button>
                        </OverlayTrigger>}
                    </div>

                </div>
            </Form.Group>
              {/* BUTTON TEXT COLOR PICKER */}
              <Form.Group className="form-group" >
                <Form.Label className="d-block"> Button Text Color

                    <br />

                    <small>
                        <i class="fa fa-info-circle mr-2"></i>
                        this will update the text colors inside all buttons. <br/>
                        <i> Refresh your personalized trainer page to see updates. </i>

                    </small>
                    <br />
                </Form.Label>
                <div className={`${classes.swatch}`}>
                    <div
                        className={`${classes.colorSelect} mb-2`}
                        style={{ background: buttonTextColor }}

                    />
                    <div className="text-center">
                        <ColorPickerOverlay
                            colorPickerDisplayed={buttonTextDisplayed}
                            setColorPickerDisplayed={setButtonTextDisplayed}
                            handleColorSave={handleColorSave}
                            dbColor={buttonTextColor}
                            type="buttonTextColor"
                        />
                          {!buttonTextDisplayed && <OverlayTrigger
                            overlay={
                                <Tooltip>Reset to default</Tooltip>
                            }>
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="ml-2"
                                onClick={() => {
                                    handleSubmit("buttonTextColor", "default");
                                    setButtonTextColor("");
                                }}
                            >
                                <i class="fas fa-undo"></i>
                            </Button>
                        </OverlayTrigger>}
                    </div>

                </div>
            </Form.Group>
        </>
    )
}

export default TrainerPageColors;